import { getCookie, setCookie } from '../../utils/cookies'
import { datalayerHandler } from '../../utils/datalayer'

export const recommendedLanguages = [
  {
    label: 'Dutch (original)',
    code: 'nl',
  },
  {
    label: 'English',
    code: 'en',
  },
  {
    label: 'Deutsch',
    code: 'de',
  },
  {
    label: 'Français',
    code: 'fr',
  },
  {
    label: 'Español',
    code: 'es',
  },
]

export const deleteGoogleCookie = (name: string) => {
  const hostname = window.location.hostname
  const splitHostname = hostname.split('.')
  const baseDomain = `${splitHostname[splitHostname.length - 2]}.${splitHostname[splitHostname.length - 1]}`
  document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
  document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; Domain=.' + baseDomain + ';'
}

export const setTranslationBannerCookie = (toggle: string) => {
  setCookie('translation_banner', toggle, 30)
}

export const isTranslationBannerCookieSet = () => {
  return getCookie('translation_banner') === 'yes'
}

export const isGoogleCookieSet = () => Boolean(getCookie('googtrans'))

export const translateDataLayerEvent = (language: string) =>
  datalayerHandler('translate_language', 'Translate language', 'translate_language', { label: language })

export const customTranslations = () => {
  if (window.google && window.google.translate) {
    const customTranslationMap: Record<string, Record<string, string>> = {
  en: {  
    // Core glossary
    'Word lid': 'Become a member',
    'Gevaarlijke stoffen': 'Dangerous goods',
    'Verpakte gevaarlijke stoffen': 'Packed dangerous goods (PGS-15)',
    'Opslag van lithiumbatterijen': 'Storage of lithium batteries (PGS 37-2)',
    'Binnenvaart': 'Inland shipping',
    'Vervoer gevaarlijke stoffen over weg': 'Transport of dangerous goods by road (ADR)',
    'Vervoer gevaarlijke stoffen per spoor': 'Transport of dangerous goods by rail (RID)',
    'Vervoer gevaarlijke stoffen over binnenwateren': 'Transport of dangerous goods by inland waterways (ADN)',
    'Vervoer gevaarlijke stoffen over zee': 'Transport of dangerous goods by sea (IMDG)',
    'Vervoer gevaarlijke stoffen door de lucht': 'Transport of dangerous goods by air (IATA)',
    'Collega-ondernemers': 'Fellow entrepreneurs',
    'BTW': 'VAT',
    'Actualiteiten': 'Latest news',
    'Magazijnen': 'Warehousing',

    // Transport core area additions
    'Eigen vervoer': 'Transport on own account',
    'Arbeidstijdenbesluit': 'Working Hours Decree',
    'Weg en vervoerswetgeving': 'Road and transport legislation',
    'Beroepsvervoer': 'Hire and reward transport',
    'Eigen wagenpark': 'Own fleet',
    'Rij- en rusttijden': 'Driving and rest periods',
    'NIWO-vergunning': 'Community licence for road transport operators',
    'Logistiek dienstverlener': 'Logistics service provider (LSP)',
    'Vervoersdocumenten': 'Transport documents',
    'CMR-vrachtbrief': 'CMR consignment note',
    'Vrachtwagenheffing': 'Truck toll',
    'CO₂-registratie': 'CO₂ emissions reporting',
    'Duurzaam vervoer': 'Sustainable transport',
    'Zero-emissie vervoer': 'Zero-emission transport',
    'Goederenvervoer': 'Freight transport',
  },
  de: {
    'Word lid': 'Mitglied werden',
  },
  fr: {
    'Word lid': 'Devenir membre',
  },
  es: {
    'Word lid': 'Hazte socio',
  },
}

    const googtrans = getCookie('googtrans') || ''
    const targetLang = googtrans.split('/').pop() || 'en'
    const translations = customTranslationMap[targetLang] || customTranslationMap['en'] || {}

    const walk = (node: Node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        let text = node.textContent || ''
        // Force brand name to always be lowercase
        text = text.replace(/evofenedex/gi, 'evofenedex')
        // Sort keys longest first to match longer phrases before shorter ones
        const keys = Object.keys(translations).sort((a, b) => b.length - a.length)
        for (const key of keys) {
          if (key.toLowerCase() === 'evofenedex') continue
          const escaped = key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
          const regex = new RegExp(escaped, 'gi')
          text = text.replace(regex, translations[key])
        }
        node.textContent = text
      } else {
        node.childNodes.forEach(walk)
      }
    }

    walk(document.body)
  }
}

export const protectedTranslationTokens = ['Signaalrood', 'Zoetermeer', 'Postbus', '2718 SG', '2700 AJ']

export const protectFromTranslation = (
  html: string,
  tokens: string[] = protectedTranslationTokens
): string => {
  if (!html || tokens.length === 0) {
    return html
  }

  const container = document.createElement('div')
  container.innerHTML = html

  const textNodes: Text[] = []
  const collect = (node: Node) => {
    node.childNodes.forEach(child => {
      if (child.nodeType === Node.TEXT_NODE) {
        textNodes.push(child as Text)
      } else {
        collect(child)
      }
    })
  }
  collect(container)

  textNodes.forEach(textNode => {
    const text = textNode.textContent || ''
    if (!tokens.some(token => text.includes(token))) {
      return
    }

    if (textNode.parentElement?.closest('.notranslate')) {
      return
    }
    const span = document.createElement('span')
    span.className = 'notranslate'
    span.setAttribute('translate', 'no')
    span.textContent = text
    textNode.parentNode?.replaceChild(span, textNode)
  })

  return container.innerHTML
}
